

import animate from './../global/animate';


export default class AriaExpand {
	constructor(toggle, el, expandClass = 'is-open', setClickHandler = true) {

		this.toggle = (toggle instanceof jQuery) ? toggle.get(0) : toggle;
		this.el = (el instanceof jQuery) ? el.get(0) : el;
		this.expandClass = expandClass;

		if (setClickHandler) {
			this.toggle.addEventListener('click', this.clickHandler.bind(this));
		}

		// set initial state from aria attribute

		if (this.toggle.getAttribute('aria-expanded') === 'true') {
			this.toggle.setAttribute('aria-expanded', 'true');
			this.toggle.classList.add(this.expandClass);
			this.el.classList.add(this.expandClass);
			
		} else {
			this.toggle.setAttribute('aria-expanded', 'false');
			this.toggle.classList.remove(this.expandClass);
			this.el.classList.remove(this.expandClass);
		}
	}

	isOpen() {
		return (this.toggle.getAttribute('aria-expanded') === 'true');
	}

	close(callback = function(){}) {
		this.toggle.setAttribute('aria-expanded', 'false');
		this.toggle.classList.remove(this.expandClass);
		animate.slideUp(this.el, this.expandClass, callback);
	}

	open(callback = function(){}) {
		this.toggle.setAttribute('aria-expanded', 'true');
		this.toggle.classList.add(this.expandClass);
		animate.slideDown(this.el, this.expandClass, callback);
	}

	clickHandler(event) {
		if(this.isOpen()){
			this.close();
		}
		else{
			this.open();
		}

	
		
	}
}